import React from "react";
import { useEffect, useState } from 'react';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { useLoader } from '@react-three/fiber';


const Scene = ({ filters, sortedProducts }) => {

    const productURL = sortedProducts[0]?.objectDownloadUrl;
    if (!productURL) {
        console.log("productURL is missing.");
        return null;
    }
    const productInitialRotation = sortedProducts[0]?.objectInitialRotation;
    const productInitialRotationRadians = Number(productInitialRotation ?? 0) * (Math.PI / 180);
    
    const selectedURL = productURL;

    const loadObjModel = (url) => {
        const selectedObjFile = url;
        const selectedMtlFile = selectedURL.replace(".obj", ".mtl");
    
        const loadedMaterials = useLoader(MTLLoader, selectedMtlFile);
        const loadedModel = useLoader(OBJLoader, selectedObjFile, (loader) => {
            loadedMaterials.preload();
            loader.setMaterials(loadedMaterials);
        });
        return loadedModel;
    }

    const loadedModel = loadObjModel(selectedURL)

    const [model, setModel] = useState(loadedModel);
    useEffect(() => {
        setModel(loadedModel);
    }, [loadedModel])
    
    const modelScale = 2.2;

    return (
        <>
            <primitive
                object={model}
                rotation={[Math.PI / 2, -Math.PI, Math.PI - productInitialRotationRadians]}
                scale={[modelScale, modelScale, modelScale]}
            />
        </>
    );
};

export default Scene;